import _ from 'lodash';

/**
 * @name ShopGoalsController
 * @description Controller for shop goals
 * @param {service} ShopGoals The ShopGoals service
 */
function ShopGoalsController(
  ShopGoals
) {
  let vm = this;
  vm.$onInit = function() {
    vm.create = create;
    vm.update = update;
    vm.isAddGoalCollapsed = true;
    vm.editCurrentGoal = false;
    vm.newGoal = {
      weekly_revenue_goal: null
    };
    get();
  };

  /**
   * @name get
   * @description Function to get shop goals
   */
  function get() {
    ShopGoals.get().then(function(goals) {
      vm.goals = goals;
      vm.currentGoal = _.find(goals, function(goal) {
        if (!goal.end_datetime) {
          return true;
        }
      });
    });
  }

  /**
   * @name create
   * @description Function to create a goal
   * @param {type} goal The goal to create
   */
  function create(goal) {
    ShopGoals.create(goal).then(function(newGoal) {
      vm.isAddGoalCollapsed = true;
      get();
      resetGoalForm();
    });
  }

  /**
   * @name update
   * @description Function to update a goal
   * @param {type} goal The goal to update
   */
  function update(goal) {
    ShopGoals.update(goal).then(function(updatedGoal) {
      get();
      vm.editCurrentGoal = false;
    });
  }

  /**
   * @name resetGoalForm
   * @description Function to reset the form back to default
   */
  function resetGoalForm() {
    vm.newGoal = {
      weekly_revenue_goal: null
    };
    vm.shopGoalForm.$setPristine();
  }
}

angular
  .module('inkfinder')
  .controller('ShopGoalsController', ShopGoalsController);



// WEBPACK FOOTER //
// ./components/shop/goals/shop-goals.controller.js